import { render, staticRenderFns } from "./SuccessCheckbox.vue?vue&type=template&id=1f2f94fe"
import script from "./SuccessCheckbox.vue?vue&type=script&lang=js"
export * from "./SuccessCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SuccessCheckbox.vue?vue&type=style&index=0&id=1f2f94fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports